import { render, staticRenderFns } from "./ReadMore.vue?vue&type=template&id=7527f6c6&scoped=true"
import script from "./ReadMore.vue?vue&type=script&lang=js"
export * from "./ReadMore.vue?vue&type=script&lang=js"
import style0 from "./ReadMore.vue?vue&type=style&index=0&id=7527f6c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7527f6c6",
  null
  
)

export default component.exports